var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:" cursor-pointer text-sm shadow select-none m-1 rounded ml-1 first:ml-2 border py-1 px-2 whitespace-no-wrap",class:_vm.getStatusClass},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }